'use strict'
import ScrollBooster from "scrollbooster";

let viewport = document.querySelector('.breadcrumbs-wrap');
if (viewport) {
    new ScrollBooster({
        viewport: viewport,
        scrollMode: 'native',
    })
}